import { Injectable, Injector, inject } from '@angular/core';
import { BpConfirmationConfig, BpErrorDialogAction } from '../models/confirmation.types';
import {
  QUALIFIED_INVESTOR_BLOCK_TITLE,
  QUALIFIED_INVESTOR_CONTACT_ADVISOR_LABEL,
  QUALIFIED_INVESTOR_CONTACT_ADVISOR_PREFILL,
} from '../models/qualified-investor.copy';
import { UtilityService } from './utility-service.service';

/**
 * Le agrega al bloqueo por Inversionista Calificado la salida que su propio mensaje promete:
 * el mensaje cierra con "contacte a su asesor" y este botón abre esa conversación con el motivo
 * ya escrito, sin que el cliente tenga que buscar el chat ni redactarlo.
 *
 * Se registra en `BP_ERROR_DIALOG_ACTIONS` (ver `main.ts`).
 */
@Injectable()
export class QualifiedInvestorErrorAction implements BpErrorDialogAction {
  /**
   * `UtilityService` inyecta el manejador de errores, que termina resolviendo el diálogo que
   * construye esta acción. Se pide al hacer clic, no al construirse, para que la cadena no se
   * cierre sobre sí misma.
   */
  private readonly injector = inject(Injector);

  /**
   * El título es lo único por lo que se reconoce el bloqueo: el diálogo lo abre el interceptor
   * global, que solo recibe el título y el mensaje del servidor. `QUALIFIED_INVESTOR_BLOCK_TITLE`
   * es el espejo de ese `displayTitle`, y un test del backend lo sostiene.
   */
  matches(config: BpConfirmationConfig): boolean {
    return config.title === QUALIFIED_INVESTOR_BLOCK_TITLE && this.isIntercomAvailable();
  }

  build() {
    return {
      show: true,
      label: QUALIFIED_INVESTOR_CONTACT_ADVISOR_LABEL,
      function: dialogRef => {
        // Cerrar antes de abrir: el messenger quedaría debajo del overlay del diálogo.
        dialogRef.close();
        this.injector
          .get(UtilityService)
          .openIntercomChat(QUALIFIED_INVESTOR_CONTACT_ADVISOR_PREFILL);
      },
    };
  }

  /** Sin el script cargado (bloqueado, o WebView sin red al arrancar) el botón no haría nada. */
  private isIntercomAvailable(): boolean {
    return typeof (window as any).Intercom === 'function';
  }
}
